import { Card } from 'semantic-ui-react';

export default Card;
